import { getTextWithContext, useTexts } from "@/context/TextContext";
import { pxToVwAreaClientes } from "@/utils/pxToVw";
import { Box, CircularProgress, Typography } from "@mui/material";

export default function FormWrapper({
  errors,
  pending,
  children,
  success,
  messageMarginBottom = false,
  validate = false,
  errorSx = {},
  ...props
}: {
  errors?: any;
  pending?: boolean;
  success?: string;
  messageMarginBottom?: false | number | string;
  validate?: boolean | (() => boolean);
  errorSx?: any;
} & React.FormHTMLAttributes<HTMLFormElement>) {
  console.log(errors);
  const context = useTexts();
  return (
    <form
      {...props}
      style={{
        position: "relative",
        top: errors?.general || success ? pxToVwAreaClientes(-18) : undefined,
      }}
      onSubmit={(e) => {
        if (validate && typeof validate === "function") {
          const isValid = validate();
          if (!isValid) {
            e.preventDefault();
          }
        }
      }}
    >
      {errors?.general && !success && (
        <>
          <Typography
            variant="body5"
            color="error"
            pl={pxToVwAreaClientes(12.5)}
            borderLeft={"1px solid #D53200"}
            position={"relative"}
            mb={
              messageMarginBottom ? messageMarginBottom : pxToVwAreaClientes(28)
            }
            sx={errorSx}
          >
            {getTextWithContext(errors.general, context)}
          </Typography>
        </>
      )}
      {success && (
        <>
          <Typography
            variant="body5"
            color="success"
            pl={pxToVwAreaClientes(12.5)}
            borderLeft={"1px solid #4BB543"}
            position={"relative"}
            mb={
              messageMarginBottom ? messageMarginBottom : pxToVwAreaClientes(28)
            }
          >
            {success}
          </Typography>
        </>
      )}
      {pending && (
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
          bgcolor="rgba(255, 255, 255, 0.7)"
          zIndex={200}
        >
          <CircularProgress />
        </Box>
      )}
      {children}
    </form>
  );
}
